import * as fromInvestor from './investor-details.state';
import * as fromRegistrants from './registrants.state';
import * as fromBank from './bank-details.state';

export interface IRegistrationStatusState {
    status: number;
    failText: string | null;
}

export const initialRegistrationStatusState: IRegistrationStatusState = {
    status: undefined,
    failText: null
};

export interface IRegistrationState {
    status: IRegistrationStatusState;
    investor: fromInvestor.IInvestorDetailsState;
    registrants: fromRegistrants.IRegistrantsState;
    banks: fromBank.IBankDetailsState;
}

export const initialRegistrationState: IRegistrationState = {
    status: initialRegistrationStatusState,
    investor: fromInvestor.initialInvestorDetailsState,
    registrants: fromRegistrants.initialRegistrantsState,
    banks: fromBank.initialBankDetailsState
};
